import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import PricesPage from './PricesPage';
import ProfilePage from './ProfilePage';



import { BrowserRouter, Routes, Route } from 'react-router-dom';
import IndexFundBalance from './components/IndexFund';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
    <BrowserRouter>
    
    <Routes>
          {/* <Route path="/">
            <Home />
          </Route> */}
          
          <Route path='/' element={<App/>} />
          <Route path="/prices" element={<PricesPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/index" element={<IndexFundBalance />} />


            
          
        </Routes>
    
    </BrowserRouter>
    </>
);


